/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Start_4_TitleInputs */

const en_mk_start_4_title = /** @type {(inputs: Mk_Start_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correct it once, it holds from then on`)
};

const id_mk_start_4_title = /** @type {(inputs: Mk_Start_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koreksi sekali, berlaku seterusnya`)
};

/**
* | output |
* | --- |
* | "Correct it once, it holds from then on" |
*
* @param {Mk_Start_4_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_start_4_title = /** @type {((inputs?: Mk_Start_4_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Start_4_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_start_4_title(inputs)
	return en_mk_start_4_title(inputs)
});